import React from 'react'
import { logger } from '../../../../logger/logger'
import { MapErrorText } from './index.styled'

class MapErrorBoundary extends React.Component {
	constructor(props) {
		super(props)
		this.state = { hasError: false }
	}

	static getDerivedStateFromError() {
		return { hasError: true }
	}

	componentDidCatch(error, info) {
		logger.error('Catch error: ', window.location.pathname, error, info.componentStack)
	}

	render() {
		if (this.state.hasError) {
			return <MapErrorText>Map Error</MapErrorText>
		}

		return this.props.children
	}
}

MapErrorBoundary.displayName = 'MapErrorBoundary'
export default MapErrorBoundary
